import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid
} from '@material-ui/core';
import DetailAppointment from './DetailAppointment';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    colors
  } from '@material-ui/core';
  import Header from '../../components/Header/Header';
  import Sidebar from '../../components/Sidebar/Sidebar';

export default class DetailAppointmentLayout extends React.Component {

    constructor(props) {
        super(props);
        console.log( this.props );

        let id = props.match.params.id;
        this.state = {
            appointment: null,
            appointment_id: id
        }
        
    }

    componentOnWilLReceiveProps(props){
        this.setState({ ...this.state, appointment_id: props.match.params.id });
    }

    render() {
        return (
            <React.Fragment>
             <Header 
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                /> 
                <main className={this.props.classes.content }>
                    <div className={this.props.classes.toolbar} /> 
                <DetailAppointment appointment_id={this.state.appointment_id} classes={this.props.classes} /> 
                    
                </main> 
                </React.Fragment>
            
        )
    }
}